export interface IMessageAdapterOptions {
  /** 持续时间 */
  dur?: number;
}

export interface IMessageAdapter {
  info(text: string, opt?: IMessageAdapterOptions): void;
  success(text: string, opt?: IMessageAdapterOptions): void;
  warn(text: string, opt?: IMessageAdapterOptions): void;
  error(text: string, opt?: IMessageAdapterOptions): void;
  clear(): IMessageAdapter;
}

export class Message implements IMessageAdapter {
  private adapter!: IMessageAdapter;

  setAdapter(adapter: IMessageAdapter): this {
    this.adapter = adapter;
    return this;
  }

  info(text: string, opt: IMessageAdapterOptions = {}): void {
    this.adapter.info(text, opt);
  }

  success(text: string, opt: IMessageAdapterOptions = {}): void {
    this.adapter.success(text, opt);
  }

  warn(text: string, opt: IMessageAdapterOptions = {}): void {
    this.adapter.warn(text, opt);
  }

  error(text: string, opt: IMessageAdapterOptions = {}): void {
    this.adapter.error(text, opt);
  }

  clear(): IMessageAdapter {
    return this.adapter.clear();
  }
}

export const message = new Message();
